import React from "react";

export const VIPriceDurationsTable = ({
  courses,
  selectedCourse,
  selectedDuration,
  viTime5,
  viTime10,
  vi40HoursDurationPrice,
  vi80HoursDurationPrice,
  vi120HoursDurationPrice,
  currencySymbol
}) => {
  return (
    <table
      key={"key-vi-price-table"}
      className="viprice-table viprice-duration-table w-full text-mob md:text-xl text-black-lighter dark:text-white"
    >
      <thead>
        <tr className="hidden md:table-row">
          <th></th>
          <th
            className="h2 py-6 border border-white dark:border-gray-lighter rounded-t-[5px] bg-yellow-standard dark:bg-gray-darkest font-light !text-white"
            colSpan={3}
          >
            Durations
          </th>
        </tr>
        <tr className="hidden md:table-row">
          <th className="w-[28%]"> </th>
          {courses.slice(0, 3).map((duration, index) => (
            <th
              className="w-[24%] border border-white dark:border-gray-lighter bg-gray-quaternary dark:bg-transparent font-semibold py-5"
              key={`mb-itm-${index}`}
            >
              {duration.viDuration} Hours
            </th>
          ))}
        </tr>

        {/* Mobile version */}

        <tr className="md:hidden">
          <th
            className="border border-white dark:border-gray-lighter !font-semibold !font-body py-5 h3 bg-gray-quaternary dark:bg-transparent"
            colSpan={2}
          >
            {" "}
            {selectedDuration} Hours
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-white dark:border-gray-lighter w-1/2 md:w-auto font-semibold">
            Study pace: {viTime5} hours / week
          </td>
          {!selectedCourse
            ? courses.map(
                (pace, index) =>
                  pace.viTime === "5" && (
                    <td
                      className="border border-white dark:border-gray-lighter font-light"
                      key={`pace-${index}`}
                    >
                      {pace.viFrequency} Weeks
                    </td>
                  )
              )
            : selectedCourse.length > 0 &&
              selectedCourse?.map(
                (pace, index) =>
                  pace.viTime === "5" && (
                    <td
                      className="border border-white dark:border-gray-lighter font-light w-1/2 md:w-auto"
                      key={`crs-pace-${index}`}
                    >
                      {pace?.viFrequency} Weeks
                    </td>
                  )
              )}
        </tr>

        <tr>
          <td className="border border-white dark:border-gray-lighter w-1/2 md:w-auto font-semibold">
            Study pace: {viTime10} hours / week
          </td>
          {!selectedCourse
            ? courses.map(
                (pace, index) =>
                  pace.viTime === "10" && (
                    <td
                      className="border border-white dark:border-gray-lighter font-light"
                      key={`dsk-cse-pce-${index}`}
                    >
                      {pace.viFrequency} Weeks
                    </td>
                  )
              )
            : selectedCourse.length > 0 &&
              selectedCourse?.map(
                (pace, index) =>
                  pace.viTime === "10" && (
                    <td
                      className="border border-white dark:border-gray-lighter font-light w-1/2 md:w-auto"
                      key={`mob-cse-pce-alt-${index}`}
                    >
                      {pace?.viFrequency} Weeks
                    </td>
                  )
              )}
        </tr>

        <tr>
          <td className="border border-white dark:border-gray-lighter rounded-bl-[5px] font-semibold">
            Price
          </td>
          {!selectedCourse ? (
            courses.slice(0, 3).map((pace, index) =>
              pace.viDuration === "40" ? (
                <td
                  className="border border-white dark:border-gray-lighter"
                  key={`dsk-cse-sm-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: `${currencySymbol}  ${vi40HoursDurationPrice}`
                  }}
                />
              ) : pace.viDuration === "80" ? (
                <td
                  className="border border-white dark:border-gray-lighter"
                  key={`dsk-cse-md-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: `${currencySymbol}  ${vi80HoursDurationPrice}`
                  }}
                />
              ) : pace.viDuration === "120" ? (
                <td
                  className="border border-white dark:border-gray-lighter"
                  key={`dsk-cse-lg-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: `${currencySymbol}  ${vi120HoursDurationPrice}`
                  }}
                />
              ) : (
                ""
              )
            )
          ) : parseInt(selectedDuration) === 40 ? (
            <td
              className="border border-white dark:border-gray-lighter"
              dangerouslySetInnerHTML={{
                __html: `${currencySymbol}  ${vi40HoursDurationPrice}`
              }}
            ></td>
          ) : parseInt(selectedDuration) === 80 ? (
            <td
              className="border border-white dark:border-gray-lighter"
              dangerouslySetInnerHTML={{
                __html: `${currencySymbol}  ${vi80HoursDurationPrice}`
              }}
            ></td>
          ) : parseInt(selectedDuration) === 120 ? (
            <td
              className="border border-white dark:border-gray-lighter"
              dangerouslySetInnerHTML={{
                __html: `${currencySymbol}  ${vi120HoursDurationPrice}`
              }}
            ></td>
          ) : (
            ""
          )}
        </tr>
      </tbody>
    </table>
  );
};
